import { useCallback, useEffect, useState } from 'react';
import APIAgent from '../../../agents/apiAgent';
import asArray from '../../../utils/asArray';

export function useOffersData({ userId, role }) {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOffers = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const endpoint = role === 'seller'
        ? `/api/offers/seller/${userId}`
        : `/api/offers/buyer/${userId}`;
      const data = await APIAgent.request(endpoint);
      setOffers(asArray(data));
      setError(null);
    } catch (err) {
      setError('Error fetching offers: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [userId, role]);

  useEffect(() => {
    fetchOffers();
  }, [fetchOffers]);

  return { offers, loading, error, refetch: fetchOffers, setOffers };
}
